import { Flex } from '@npco/zeller-design-system'

export const CashflowFiltersHeader = () => {
  return (
    <Flex width="100%" justifyContent="space-between">
      <div>All Accounts</div>
      <div>Last 12 Months</div>
    </Flex>
  )
}
